import { render, staticRenderFns } from "./SsoRegistrationSpPage.vue?vue&type=template&id=495d22ac"
import script from "./SsoRegistrationSpPage.vue?vue&type=script&lang=js"
export * from "./SsoRegistrationSpPage.vue?vue&type=script&lang=js"
import style0 from "./SsoRegistrationSpPage.vue?vue&type=style&index=0&id=495d22ac&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports